/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h2[_ngcontent-%COMP%]{margin-top:20px}.mat-icon[_ngcontent-%COMP%]{color:rgba(0,0,0,.12)}.mat-list-icon[_ngcontent-%COMP%]{color:#fff;background:rgba(58,50,50,.3)}a[_ngcontent-%COMP%]{text-decoration:none!important}table[_ngcontent-%COMP%]{width:100%}td[_ngcontent-%COMP%]{padding:5px;font-size:22px;border:1px solid}"];
export { styles as styles };
